import { Box, Fade, Paper } from '@mui/material';
import { useCallback, useEffect, useRef } from 'react';
import PageTitle from '@acorn-portal/shared/src/components/text/PageTitle';
import { useAppDispatch } from '@acorn-portal/shared/src/hooks/reduxHook';
import PolicyList from '@acorn-portal/shared/src/components/list/policy-list';
import { usePolicyOverviews } from '@acorn-portal/shared/src/models/policy-model';
import { getPolicyRoute } from '@acorn-portal/shared/src/utils/policy-routes';
import { Navigate } from 'react-router';
import { getLists } from '@acorn-portal/shared/src/store/referenceData.slice';
import FullPageLoadingSplash from '@acorn-portal/shared/src/components/loading/FullPageLoadingSplash';
import NoPolicyDetailsCopy from '@acorn-portal/shared/src/pages/misc/portal-home/components/no-policy-details-copy';
import useTrack from '@acorn-portal/shared/src/hooks/useTrack/useTrack';

const PortalHome = () => {
	const { loadingState, policies, paging } = usePolicyOverviews(5);
	const dispatch = useAppDispatch();
	const { track } = useTrack();

	useEffect(() => {
		track(`Portal Home Page Viewed`);
	}, []);

	const isLoadingRefData = useRef(false);

	const fetchReferenceData = useCallback(async () => {
		if (isLoadingRefData.current) {
			return;
		}
		isLoadingRefData.current = true;
		dispatch(getLists()).finally(() => {
			isLoadingRefData.current = false;
		});
	}, [dispatch]);

	useEffect(() => {
		fetchReferenceData().catch(console.error);
	}, [fetchReferenceData]);

	if (!loadingState.isLoading && policies.length < 1) {
		return <NoPolicyDetailsCopy />;
	}

	if (!loadingState.isLoading && paging.totalItemCount === 1) {
		const policy = policies[0];
		if (policy) {
			return <Navigate to={getPolicyRoute(policy.product, policy.policyToken, policy.policyNumber)} replace />;
		}
	}

	return (
		<FullPageLoadingSplash message='Fetching Policy Details...' loading={loadingState.isLoading}>
			<Paper
				elevation={1}
				sx={{
					borderRadius: '8px',
				}}
			>
				<Fade in>
					<Box
						sx={{
							margin: { xs: 2, md: '2rem' },
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
						}}
					>
						<PageTitle>Your Policies</PageTitle>
						<PolicyList policies={policies} paging={paging} isPaging={loadingState.isPaging} />
					</Box>
				</Fade>
			</Paper>
		</FullPageLoadingSplash>
	);
};

export default PortalHome;
